import { render, staticRenderFns } from "./learns.vue?vue&type=template&id=2aff4ef5&"
import script from "./learns.vue?vue&type=script&lang=js&"
export * from "./learns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports